$(function () {

  $('.js-countfavs').on('click', function () {
    const post_id = $(this).attr('data-postid');
    const type = $(this).attr('data-type');
    const button = $('.js-countfavs');
    const num = button.find('.num');

    if(button.hasClass('is-voted')){
      return false;
    }

    $.ajax({
      type: "POST",
      url: ajaxurl,
      data: {
        'action': 'webliker_countup_favs',
        'count_type': type,
        'post_id': post_id
      }
    }).done(function (data) {
      $(num).text(data);
      $(button).addClass('is-voted');

    }).fail(function (XMLHttpRequest, textStatus, error) {
      console.log(error);
    });
  });

});
